/**
 * Presets query keys — the reference implementation for the hierarchical key factory
 * (Server-state rebuild, P0). Every domain factory follows the same shape:
 *
 *   all()            → the domain root; invalidating it cascades to every child
 *   lists()/list(f)  → collection queries (filters via `stableFilters`)
 *   details()/detail → single-entity queries
 *   <sub-resource>   → nested under detail() so a parent key is a strict PREFIX of its
 *                      children and prefix-invalidation cascades correctly
 *
 * Invariant: every variable segment (id) precedes any constant sub-resource segment.
 */
export const presetKeys = {
  all: () => ['presets'] as const,
} as const;
